// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adHs-cont{
    border: 1px solid black;
    margin: 10px;
    height: 80vh;
    overflow: auto;
}
.btn{
    margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/Components/Css/AdminHistory.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;AACA;IACI,YAAY;AAChB","sourcesContent":[".adHs-cont{\n    border: 1px solid black;\n    margin: 10px;\n    height: 80vh;\n    overflow: auto;\n}\n.btn{\n    margin: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
